import Link from 'next/link'
import {RiEmotionSadLine} from 'react-icons/ri';


const CartEmpty = ()=>{
    return <div className="cartEmpty marginBottom">
        <div>
            <RiEmotionSadLine/>
            <h1 className="title">Tu carrito esta vacio</h1>
            <p className="cartDescription">Agrega un producto a tu carrito para que puedas continuar con tu compra.</p>
            <p>Te sugerimos ver
                <Link href='/floreria-cdmx-edomex'>
                    <a> nuestro catalogo completo</a>
                </Link></p>
        </div>
    </div>
};

export default CartEmpty;